import { render, staticRenderFns } from "./StatCommon.vue?vue&type=template&id=3acac015&lang=pug&"
import script from "./StatCommon.vue?vue&type=script&lang=js&"
export * from "./StatCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports